export const blog = () => {
    jQuery(document).ready(function ($) {
        $(document).on('click', '#load-more-posts', function (e) {
            e.preventDefault();

            var $button = $(this);
            var $container = $('.posts-list');
            var currentPage = parseInt($button.closest('.load-more-container').attr('data-current-page'), 10);
            var maxPages = parseInt($button.closest('.load-more-container').attr('data-max-pages'), 10);

            var nextPage = currentPage + 1;

            $.ajax({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                data: {
                    action: 'load_more_posts',
                    page: nextPage
                },
                success: function (response) {
                    if (response) {
                        $container.append(response);
                        $button.closest('.load-more-container').attr('data-current-page', nextPage);
                        if (nextPage >= maxPages) {
                            $button.remove();
                        }
                    } else {
                        $button.remove();
                    }
                },
                error: function () {
                    console.error('Error while loading more posts.');
                }
            });
        });
    });

    jQuery(document).ready(function ($) {
        function moveCategories() {
            $(".post-item").each(function () {
                const $post = $(this);
                const $postCategories = $post.find(".post-categories");
                const $postThumbnailLink = $post.find(".post-thumbnail-link");
                const $postInfo = $post.find(".post-info");

                if (!$postCategories.length || !$postThumbnailLink.length || !$postInfo.length) return;

                if ($(window).width() <= 600) {
                    if ($postCategories.parent()[0] !== $postThumbnailLink[0]) {
                        $postThumbnailLink.append($postCategories);
                    }
                } else {
                    if ($postCategories.parent()[0] !== $postInfo[0]) {
                        $postInfo.prepend($postCategories); 
                    }
                }
            });
        }

        let resizeTimeout;
        $(window).on("resize", function () {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(moveCategories, 100);
        });

        moveCategories(); 
        const observer = new MutationObserver(() => {
            moveCategories();
        });

        observer.observe(document.body, { childList: true, subtree: true });
    });
}
    document.addEventListener("DOMContentLoaded", function () {
        const categoryList = document.querySelector(".category-block ul");

        let isDown = false;
        let startX;
        let scrollLeft;

        categoryList.addEventListener("mousedown", (e) => {
            isDown = true;
            startX = e.pageX - categoryList.offsetLeft;
            scrollLeft = categoryList.scrollLeft;
        });

        categoryList.addEventListener("mouseleave", () => {
            isDown = false;
        });

        categoryList.addEventListener("mouseup", () => {
            isDown = false;
        });

        categoryList.addEventListener("mousemove", (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - categoryList.offsetLeft;
            const walk = (x - startX) * 2; // Скорость прокрутки
            categoryList.scrollLeft = scrollLeft - walk;
        });
    });

    document.addEventListener("DOMContentLoaded", function () {
        const categoryList = document.querySelector(".category-block ul");
        const categoryBlock = document.querySelector(".category-block");
        const scrollButton = document.createElement("div");

        scrollButton.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 14 14" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.5781 7.03064C11.5781 7.32533 11.3392 7.56424 11.0445 7.56423H3.49842C3.20372 7.56424 2.96482 7.32533 2.96483 7.03064C2.96483 6.73594 3.20369 6.49708 3.49839 6.49707H11.0446C11.3393 6.49708 11.5781 6.73594 11.5781 7.03064Z" fill="#DCF34B"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.89418 2.88027C7.10256 2.67189 7.44041 2.67189 7.64879 2.88027L11.4219 6.65335C11.6302 6.86172 11.6302 7.19958 11.4219 7.40796L7.64879 11.181C7.44042 11.3894 7.10255 11.3894 6.89418 11.181C6.6858 10.9727 6.6858 10.6348 6.89418 10.4264L10.2899 7.03065L6.89418 3.63488C6.6858 3.4265 6.6858 3.08865 6.89418 2.88027Z" fill="#DCF34B"/>
        </svg>
    `;
        scrollButton.classList.add("scroll-button");
        categoryBlock.appendChild(scrollButton);

        function updateUI() {
            const maxScrollLeft = categoryList.scrollWidth - categoryList.clientWidth;
            const currentScroll = categoryList.scrollLeft;

            categoryBlock.style.setProperty("--gradient-opacity", currentScroll >= maxScrollLeft - 10 ? "0" : "1");

            scrollButton.style.opacity = currentScroll >= maxScrollLeft - 10 ? "0" : "1";
        }


        scrollButton.addEventListener("click", function () {
            categoryList.scrollBy({ left: 100, behavior: "smooth" });
        });


        categoryList.addEventListener("scroll", updateUI);
        updateUI();
    });


    jQuery(document).ready(function ($) {
        var postIds = [];
        $('.likes-post, .likes-block').each(function () {
            var postId = $(this).data('postid');
            if (postId && postIds.indexOf(postId) === -1) {
                postIds.push(postId);
            }
        });

        if (postIds.length > 0) {
            $.ajax({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'get_post_like_count',
                    post_ids: postIds
                },
                success: function (response) {
                    if (response.success) {
                        $.each(response.data, function (postId, count) {
                            $('.likes-post[data-postid="' + postId + '"]').find('.like-count').text(count);
                            $('.likes-block[data-postid="' + postId + '"]').find('.like-count').text(count);
                        });
                    } else {
                        console.error('Error:', response.data);
                    }
                },
                error: function (xhr, status, error) {
                    console.error('AJAX error:', error);
                }
            });
        }
    });

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".most-recent-post-item-right").forEach(item => {
        const categories = item.querySelectorAll(".most-recent-post-categories a");
        const titleLink = item.querySelector("h2 > a");

        if (categories.length <= 3 && titleLink) {
            titleLink.style.webkitLineClamp = "3";
            titleLink.style.webkitBoxOrient = "vertical";
            titleLink.style.overflow = "hidden";
            titleLink.style.display = "-webkit-box";
        }
    });
});

document.addEventListener("DOMContentLoaded", function () {
    setTimeout(() => {
        document.querySelectorAll(".post-info").forEach(item => {
            const categories = item.querySelectorAll(".post-categories a");
            const titleLink = item.querySelector("h3 > a");

            if (categories.length <= 3 && titleLink) {
                titleLink.style.display = "-webkit-box";
                titleLink.style.webkitBoxOrient = "vertical";
                titleLink.style.webkitLineClamp = "4";
                titleLink.style.overflow = "hidden";
            }
        });
    }, 500);
});
